import { useContext, useEffect } from 'react';

import fullStory from 'js/lib/fullStoryUtils';

import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';

export default function GradingFullStory() {
  const {
    submissionData,
    pageData: {
      courseId,
      courseBranchId,
      currentItem,
      currentItemId,
      gradingGroupId,
      currentCourseSlug,
      currentContextId,
    },
  } = useContext(SGAPageContext);

  const { submission } = submissionData.data || {};

  useEffect(() => {
    fullStory.init();

    fullStory.set({
      isQuickGrader: true,
      courseId,
      courseBranchId,
      currentItemId,
      gradingGroupId,
      currentCourseSlug,
      currentContextId,
      currentItemName: currentItem.name,
      currentItemIsGraded: currentItem.isGraded,
      currentQuestionId: submission?.currentQuestionId,
      currentRubricId: submission?.currentRubricId,
    });

    return () => fullStory.endSession();
  });

  return null;
}
